import Vue from 'vue'
import qs from 'qs';
import VueRouter from 'vue-router';
import axios from 'axios';
import routes from '@/common/routes';
import ElementUI from 'element-ui';
import App from './App.vue';

import 'element-ui/lib/theme-chalk/index.css';
require('./scss/main.scss');



Vue.use(ElementUI);
Vue.use(VueRouter);


axios.defaults.withCredentials = true;
axios.defaults.baseURL =  process.env.VUE_APP_BASE_API;
axios.defaults.transformRequest.unshift(function (data) {
  data = qs.stringify(data);
  return data;
});

const router = new VueRouter({
  //mode: 'history',
  mode: process.env.VUE_APP_ROUTER||'history',
  routes, // （缩写）相当于 routes: routes

})




const app = new Vue({
  router,
  data() {
    return {}
  },
  computed: {

  },
  methods:{

  },
  watch: {

  },
  created() {

  },
  render: h => h(App),
}).$mount('#app');

//app.currentRoute=router.currentRoute && router.currentRoute.name;
window.APP = app;
